import { render, staticRenderFns } from "./checkboxItem.vue?vue&type=template&id=ff7acc16&scoped=true"
import script from "./checkboxItem.vue?vue&type=script&lang=js"
export * from "./checkboxItem.vue?vue&type=script&lang=js"
import style1 from "./checkboxItem.vue?vue&type=style&index=1&id=ff7acc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7acc16",
  null
  
)

export default component.exports